document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".show-more-radios").forEach(button => {
        button.addEventListener("click", function() {
            const radiosContainer = this.closest(".radios--container");
            radiosContainer?.querySelectorAll(".hidden-radio").forEach(el => el.classList.remove("hidden-radio"));
            this.style.display = "none";
        });
    });
});



let radios = document.querySelectorAll('.product-form--variants .radios--container input[type="radio"]');

const thumbSwiper = new Swiper(".js-thumb-swiper", {
    slidesPerView: 5,
    spaceBetween: 16,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".js-thumb-swiper .swiper-button-next",
        prevEl: ".js-thumb-swiper .swiper-button-prev"
    }
});

const mainSwiper = new Swiper(".js-main-swiper", {
    slidesPerView: 1,
    spaceBetween: 10,
    initialSlide: 1,
    thumbs: {
        swiper: thumbSwiper,
    },
});

if (radios.length > 0) {
    function getVariantIdFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("variant");
    }

    function getVariantObject(variantId) {
        if (!window.productVariants) return null;
        return window.productVariants.find(variant => variant.id == variantId);
    }

    function slideToVariantMedia(variant) {
        if (!variant || !variant.featured_media) return;

        const mediaId = variant.featured_media.id.toString();
        const slides = document.querySelectorAll(".js-main-swiper .swiper-slide");

        let targetIndex = -1;

        slides.forEach((slide, index) => {
            if (slide.dataset.mediaId === mediaId) {
                targetIndex = index;
            }
        });

        if (targetIndex !== -1) {
            mainSwiper.slideTo(targetIndex);
        }
    }

    radios.forEach(radio => {
        radio.addEventListener('change', () => {
            setTimeout(() => {
                const variantId = getVariantIdFromUrl();
                const variantObject = getVariantObject(variantId);
                slideToVariantMedia(variantObject);
            }, 500);
        });
    });

    const variantId = getVariantIdFromUrl();
    const variantObject = getVariantObject(variantId);
    slideToVariantMedia(variantObject);

    (() => {
      const klaviyoOTSBTN = document.querySelector(".klaviyo-bis-trigger");

      if (!klaviyoOTSBTN) return;

      if (variantObject.available) {
        klaviyoOTSBTN.style.display = "none";
      } else {
        klaviyoOTSBTN.style.display = "block";
      }
    })();
}


document.addEventListener('DOMContentLoaded', function() {
    function swapImage(colorValue, productContainer) {
        const variantImageUrl = productContainer
            .querySelector(`.radios--input[value="${colorValue}"]`)
            ?.closest('.radios--main')
            ?.querySelector('.radios--swatch-button')
            ?.style.backgroundImage.match(/url\("(.+)"\)/)?.[1];

        if (variantImageUrl) {
            const mainImage = productContainer.querySelector('.product--image img');
            if (mainImage) mainImage.srcset = variantImageUrl;
        }
    }

    function setDefaultSelectedVariant() {
        document.querySelectorAll('.product--root').forEach(productContainer => {
            productContainer.querySelector('.radios--swatch-button')?.classList.add('selected-variant');
        });
    }

    document.querySelectorAll('.radios--swatch-button').forEach(swatch => {
        swatch.addEventListener('click', function() {
            const productContainer = this.closest('.product--root');
            productContainer.querySelectorAll('.radios--swatch-button').forEach(button =>
                button.classList.remove('selected-variant')
            );
            this.classList.add('selected-variant');
            swapImage(this.closest('.radios--main').querySelector('.radios--input').value, productContainer);
        });
    });

    setDefaultSelectedVariant();
});